import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, shape, func, string } from "prop-types";
import { Col, Row } from "react-bootstrap";
import { Form, Field, Formik } from "formik";
import * as Yup from "yup";
import { isIOS } from "react-device-detect";

import { selectors as investmentfundsSelectors, actions as investmentfundsActions } from "reducers/investmentfunds";
import { selectors as sessionSelectors } from "reducers/session";

import * as i18n from "util/i18n";

import PageLoading from "pages/_components/PageLoading";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import Credential from "pages/_components/fields/credentials/Credential";
import I18n from "pages/_components/I18n";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import Check from "pages/_components/fields/Checkbox";

class AddAccountFormConfirm extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        history: shape({ goBack: func }),
        fetchingSubmit: bool.isRequired,
        fetching: bool.isRequired,
        accountData: shape({}).isRequired,
        username: string.isRequired,
    };

    static defaultProps = {
        history: null,
    };

    state = {
        checked: false,
    };

    handleCheckboxChange = (checked) => {
        this.setState({ checked: checked.target.checked });
    };

    handleSubmit = (values, formikBag) => {
        const { dispatch, accountData, username } = this.props;
        if (values) {
            const params = {
                name: accountData.name,
                mail: accountData.mail,
                phone: accountData.phone,
                accountSummary: accountData.accountSummary,
                username,
                ddjj: accountData.ddjj,
                documentToUpload: accountData.documentToUpload,
                idTransaction: accountData.idTransaction,
                _otp: values.credential,
                formikBag,
            };
            dispatch(investmentfundsActions.addAccountSend(params));
        }
    };

    validationSchema = () =>
        Yup.lazy(() =>
            Yup.object().shape({
                credential: Yup.string().required(i18n.get("global.error.required")),
            }),
        );

    render() {
        const { fetching, fetchingSubmit, history, isDesktop, accountData, dispatch } = this.props;
        const { checked } = this.state;

        return (
            accountData && (
                <PageLoading loading={fetching}>
                    <Notification scopeToShow="investmentfunds" />

                    <ResponsiveHeader
                        id="investmentFunds.add.account.title"
                        className="header-without-button"
                        onClickBack={history.goBack}
                    />
                    <MainContainer className="loans">
                        <I18n component="h3" id="investmentFunds.add.account.confirm.subtitle" />

                        <Formik onSubmit={this.handleSubmit} validationSchema={this.validationSchema}>
                            {({ values }) => {
                                const disabled = !values.credential || !checked;
                                return (
                                    <Form>
                                        <Row className="form-background pt-6">
                                            <div style={{ padding: "0px 24px 0px 24px" }}>
                                                <I18n component="h2" id="debin.addrecurence.beneficiary" />
                                                <GridTable className="equivalent-total-balance">
                                                    <GridTable.Container columns={2} columnsTemplate="fixed">
                                                        <GridTable.Data columnStart={1} rowStart={1}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "investmentFunds.add.account.name.confirm.label",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={accountData.name ? accountData.name : "-"}
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data
                                                            columnStart={isDesktop ? 2 : 1}
                                                            rowStart={isDesktop ? 1 : 2}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "investmentFunds.add.account.mail.label",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={accountData.mail}
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 3}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "investmentFunds.add.account.phone.label",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={accountData.phone}
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data
                                                            columnStart={isDesktop ? 2 : 1}
                                                            rowStart={isDesktop ? 2 : 4}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "investmentFunds.add.account.accountSummary.label",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={accountData.accountSummary}
                                                            />
                                                        </GridTable.Data>
                                                    </GridTable.Container>
                                                </GridTable>
                                            </div>
                                        </Row>

                                        <Row className="form-actions">
                                            <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={4}>
                                                <div className="d-flex align-items-center">
                                                    <div style={isIOS ? { width: "var(--space-9)" } : null}>
                                                        <Check
                                                            hideLabel
                                                            name="termsAndConditios"
                                                            onChange={this.handleCheckboxChange}
                                                            checked={checked}
                                                        />
                                                    </div>
                                                    <div className="d-flex pb-4">
                                                        <div className={isIOS ? "whitespace-nowrap pr-3" : "pr-3"}>
                                                            {i18n.get(
                                                                "investmentFunds.add.account.confirm.ddjj.accept",
                                                            )}
                                                        </div>
                                                        <div
                                                            aria-hidden="true"
                                                            className={
                                                                isIOS ? "whitespace-nowrap btn-link" : "btn-link"
                                                            }
                                                            onClick={() => {
                                                                dispatch(investmentfundsActions.downloadAccountTerms());
                                                            }}>
                                                            {i18n.get("investmentFunds.add.account.confirm.ddjj.check")}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={4} mdOffset={2}>
                                                <Field
                                                    component={Credential}
                                                    idForm="form.credential"
                                                    name="credential"
                                                    type="otp"
                                                    labelText="form.credential.token.label"
                                                    placeholderText="Ej: 120573"
                                                />
                                            </Col>
                                            <Col xs={12} md={4} mdOffset={6} className="align-items-end">
                                                <div className="form-group hidden-label">
                                                    <div className="button-group">
                                                        <Button
                                                            block
                                                            type="submit"
                                                            label="global.confirm"
                                                            bsStyle="primary"
                                                            loading={fetchingSubmit}
                                                            disabled={disabled}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </MainContainer>
                </PageLoading>
            )
        );
    }
}
const mapStateToProps = (state) => ({
    fetchingSubmit: investmentfundsSelectors.getFetchingSubmit(state),
    fetching: investmentfundsSelectors.getFetching(state),
    accountData: investmentfundsSelectors.getAccountData(state),
    username: sessionSelectors.getUserFullName(state),
});
export default connect(mapStateToProps)(AddAccountFormConfirm);
